'use strict';

import $ from 'jquery';

$(function() {
  $("#modal-manifestacao")
      .on('ajax-loaded', function() { $(this).focusFirst(); });
});
